export const supplier = [
    {
        path: '/suppliers',
        name: '供应商管理',
        component: () => import("@/views/layout/index.vue"),
        // isDelete:false,
        children: [
            {
                path: 'details',
                component: () => import("@/views/sellerAdmin/supplier/details/index.vue"),
                name: '供应商详情',
                meta: {
                    hidden: true,
                    key: 14002,
                },
            },
            // {
            //   path: 'withdraw',
            //   component: () => import("@/views/sellerAdmin/withdraw/index.vue"),
            //   name: '提现详情',
            //   meta: {
            //       hidden: true,
            //       key: 14007,
            //   },
            // },
            {
                path: 'withdraw',
                component: () => import("@/views/sellerAdmin/withdraw/second/index.vue"),
                name: '商家配置',
                meta: {
                    hidden: true,
                    key: 14007,
                },
              },
            {
                path: 'release/:id?',
                component: () => import("@/views/sellerAdmin/marketing/wares/product-release/index.vue"),
                name: '商品发布',
                meta: {
                    hidden: true,
                    key: 14001,
                    path:'/suppliers/merchan-dising'
                },
            },
            {
                path: 'merchan-dising',
                component: () => import("@/views/sellerAdmin/marketing/wares/merchan-dising/index.vue"),
                name: '商品管理',
                meta: {
                    hidden: true,
                    key: 14003,
                    path:'/suppliers/release'
                },
            },

            {
                path: 'order',
                component: () => import("@/views/sellerAdmin/supplier/order/index.vue"),
                name: '订单管理',
                meta: {
                    hidden: true,
                    key: 14004,
                },
                redirect: 'order/list',
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/supplier/order/default/index.vue"),
                        name: '订单列表',
                        meta: {
                            hidden: true,
                            parent: '/suppliers/order',
                            isShow:false,
                            key: 14004,
                        },
                    },
                    {
                        path: 'details/:id/:isEdit?',
                        component: () => import("@/views/sellerAdmin/supplier/order/details/index.vue"),
                        name: '订单详情',
                        meta: {
                            hidden: true,
                            parent: '/suppliers/order',
                            isShow:false,
                            key: 14004,
                        },
                    },
                ]
            },
            {
              path: 'purchase',
              component: () => import("@/views/sellerAdmin/supplier/purchase/index.vue"),
              name: '批采订货',
              meta: {
                  hidden: true,
                  key: 14005,
              },
            },
            {
              path: 'purchase-order',
              component: () => import("@/views/sellerAdmin/supplier/purchase-order/index.vue"),
              name: '批采订单',
              meta: {
                  hidden: true,
                  key: 14006,
                  user:"supplier"
              },
            },
        ]
    },

]
